import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root',
})

export class LoginService{

  constructor(private http: HttpClient){}

}
